import { Menu } from "lucide-react";
import { Outlet } from "react-router";
import { AppSidebar } from "@/components/app-sidebar";
import { Button } from "@/components/ui/button";
import {
  SidebarInset,
  SidebarProvider,
  useSidebar,
} from "@/components/ui/sidebar";
import { useAuth } from "@/hooks/auth/use-auth";
import { useAccountSelection } from "@/hooks/use-account-selection";
import { BuyingGroupSelectionProvider } from "@/hooks/use-buying-group-selection";
import { PostHogAnalytics } from "@/lib/posthog";

function MobileTopNav() {
  const { toggleSidebar } = useSidebar();

  return (
    <div className="h-14 border-b bg-background fixed top-0 left-0 right-0 z-50 flex items-center md:hidden">
      <Button
        variant="ghost"
        size="icon"
        className="h-10 w-10 ml-2"
        onClick={toggleSidebar}
      >
        <Menu className="h-5 w-5" />
        <span className="sr-only">Toggle menu</span>
      </Button>
    </div>
  );
}

export default function AppLayout() {
  const { isAuthenticated, isLoading } = useAuth();
  const { selectedAccountId } = useAccountSelection();

  const sidebarCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("sidebar_state="));

  // Default to true (open) unless explicitly set to false in cookie
  const defaultOpen = sidebarCookie
    ? sidebarCookie.split("=")[1] === "true"
    : true;

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return null;
  }

  return (
    <SidebarProvider
      defaultOpen={defaultOpen}
      className="relative h-screen w-screen bg-background overflow-hidden"
    >
      <BuyingGroupSelectionProvider accountId={selectedAccountId}>
        <PostHogAnalytics>
          <AppSidebar className="bg-background" />
          <MobileTopNav />
          <SidebarInset>
            <main className="h-full overflow-y-auto py-2 px-4 bg-muted md:mt-0 mt-14">
              <Outlet />
            </main>
          </SidebarInset>
        </PostHogAnalytics>
      </BuyingGroupSelectionProvider>
    </SidebarProvider>
  );
}
